import { render } from "./BtnFeedback.vue?vue&type=template&id=90b11942"
import script from "./BtnFeedback.vue?vue&type=script&lang=js"
export * from "./BtnFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__